<template>
  <page>
    <div>
      <!-- Add Filters here -->
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete
                            :items="poltype"
                            v-model="filter.polType"
                            :label="label.polType"
                            item-text="label"
                            item-value="value"
                            data-vv-name="polType"
                            :data-vv-as="label.polType"
                            :error-messages="errors.collect('polType')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete
                            :items="buscls"
                            v-model="filter.busCls"
                            :label="label.busCls"
                            item-text="label"
                            item-value="value"
                            data-vv-name="busCls"
                            :data-vv-as="label.busCls"
                            :error-messages="errors.collect('busCls')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete
                            :items="stdrisktxt"
                            v-model="filter.stdRiskTxtRef"
                            :label="label.stdRiskTxtRef"
                            item-text="label"
                            item-value="value"
                            data-vv-name="stdRiskTxtRef"
                            :data-vv-as="label.stdRiskTxtRef"
                            :error-messages="errors.collect('stdRiskTxtRef')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class=" mr-2" @click="doNew">
            New Default Standard Risk Text
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              :server-items-length="totalItems"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.polType }}</td>
                  <td class="text-xs-left">{{ row.item.busCls }}</td>
                  <td class="text-xs-left">{{ row.item.riskNo }}</td>
                  <td class="text-xs-left">{{ row.item.stdRiskTxtRef }}</td>
                  <td class="table-action-header">
                    <table-action :rowData="row" query @query="doQuery(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doDelete">
        <p>Are you sure you want to delete the selected Default Standard Risk Text?</p>
        <div class="queryValue">
          Policy Type: {{ selected.polType }}<br />
          Business Class: {{ selected.busCls }}<br />
          Standard Risk Text Reference: {{ selected.stdRiskTxtRef }}
        </div>
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      toogleArray: [false],
      poltype: [],
      buscls: [],
      busClsByPolTypeCls: [],
      stdrisktxt: [],
      items: [],
      label: {
        polType: 'Policy Type',
        busCls: 'Business Class',
        riskNo: 'Risk No.',
        stdRiskTxtRef: 'Standard Risk Text Reference'
      },
      filter: {
        polType: null,
        busCls: null,
        stdRiskTxtRef: null
      },
      loading: false,
      totalItems: 0,
      headers: [
        { text: 'Policy Type', align: 'left', value: 'polType' },
        { text: 'Business Class', align: 'left', value: 'busCls' },
        { text: 'Risk No.', align: 'left', value: 'riskNo' },
        { text: 'Risk Text Reference', align: 'left', value: 'stdRiskTxtRef' },
        TableConst.tableActionHeader
      ],
      promptRemove: false,
      selected: {
        polType: null,
        busCls: null,
        riskNo: null,
        stdRiskTxtRef: null
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
    // this.fetchData()
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataListDropDown('poltype')
      this.getCommonDataListDropDown('buscls')
      this.getCommonDataListDropDown('stdrisktxt')
      this.fetchData()
      // this.fetchStdRiskItemTxt()
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getDefStdRiskTxtPage
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filter, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  polType: datamap.polType,
                  busCls: datamap.busCls,
                  riskNo: datamap.riskNo,
                  stdRiskTxtRef: datamap.stdRiskTxtRef
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    // async fetchStdRiskItemTxt() {
    //   const apiUrl = this.menu.stdRiskItemTxtList
    //   if (apiUrl) {
    //     try {
    //       this.stdriskitemtxt = []
    //       const result = await this.$http.get(apiUrl)
    //       if (result.data.dataList) {
    //         this.$set(this, 'stdriskitemtxt', result.data.dataList)
    //       }
    //     } catch (err) {
    //       this.stdriskitemtxt = []
    //       const { data } = err.response
    //       if (data) {
    //         this.message(data)
    //       }
    //     }
    //   } else {
    //     this.errorMessage('The request failed because it is trying to execute an invalid API url.')
    //   }
    // },
    doNew() {
      this.$router.push({ name: 'defStdRiskTxtDet', params: { defStdRiskTxt: 'new', tranMode: 'New' } })
    },
    doQuery(data) {
      this.$router.push({ name: 'defStdRiskTxtDet', params: { defStdRiskTxt: data, tranMode: 'Query' } })
    },
    doReview(data) {
      this.$router.push({ name: 'defStdRiskTxtDet', params: { defStdRiskTxt: data, tranMode: 'Review' } })
    },
    doPromptRemove(data) {
      if (data) {
        this.resetMessages()
        this.selected.polType = data.polType
        this.selected.busCls = data.busCls
        this.selected.riskNo = data.riskNo
        this.selected.stdRiskTxtRef = data.stdRiskTxtRef
        this.promptRemove = true
      }
    },
    async doDelete() {
      if (this.selected && this.selected.stdRiskTxtRef) {
        const apiURI = this.menu.deleteDefStdRiskTxt
        if (apiURI) {
          const expand = {
            polType: this.selected.polType,
            busCls: this.selected.busCls,
            riskNo: this.selected.riskNo,
            stdRiskTxtRef: this.selected.stdRiskTxtRef
          }
          this.$http
            .post(apiURI, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.fetchData()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.fetchData()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doClearFilters() {
      this.resetMessages()
      this.filter.polType = undefined
      this.filter.busCls = undefined
      this.filter.stdRiskTxtRef = undefined
      this.fetchData()
    }
    // doGetItemByRisk(event) {
    //   if (this.filter.stdRiskTxtRef !== '') {
    //     this.stdriskitemtxt = []
    //     const apiURI = this.menu.getStdRiskItemTxtListByStdRiskTxt
    //     if (apiURI) {
    //       const expand = {
    //         stdRiskTxtRef: this.filter.stdRiskTxtRef
    //       }
    //       this.$http.get(expandURI(apiURI, expand)).then(results => {
    //         if (results.data.dataList) {
    //           this.$set(this, 'stdriskitemtxt', results.data.dataList)
    //         } else {
    //           this.filter.busCls = ''
    //           this.fetchStdRiskItemTxt()
    //         }
    //       }).catch(err => {
    //         this.stdriskitemtxt = []
    //         const { data } = err.response
    //         if (data) {
    //           this.fieldMessage(data)
    //           this.notify(data)
    //         }
    //       })
    //     }
    //   } else {
    //     this.filter.busCls = ''
    //     this.fetchStdRiskItemTxt()
    //   }
    // }
  },
  computed: {
    menu() {
      return this.$store.state.defStdRiskTxtParam.menu
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>
